module.exports = __webpack_public_path__ + "static/media/cyclist.05d97c93.jpg";